/**
 * Decode agent tile frames: u32le jsonLen | TileFrameMessage JSON | length-prefixed tiles.
 */

import type { MoveRect, TileFrameMessage, TileImageCodec, TileRect } from "@srd/shared";

export interface DecodedTileFrame {
  meta: TileFrameMessage;
  tileBytes: Uint8Array[];
}

export function decodeTileFrameBinary(buffer: ArrayBuffer): DecodedTileFrame | null {
  if (buffer.byteLength < 4) return null;
  const view = new DataView(buffer);
  const jsonLen = view.getUint32(0, true);
  if (jsonLen <= 0 || buffer.byteLength < 4 + jsonLen) return null;
  const jsonBytes = new Uint8Array(buffer, 4, jsonLen);
  let meta: TileFrameMessage;
  try {
    meta = JSON.parse(new TextDecoder().decode(jsonBytes)) as TileFrameMessage;
  } catch {
    return null;
  }
  if (meta?.v !== 1 || meta.type !== "tile_frame" || !Array.isArray(meta.tiles)) {
    return null;
  }

  const tileBytes: Uint8Array[] = [];
  let o = 4 + jsonLen;
  for (let i = 0; i < meta.tiles.length; i++) {
    if (buffer.byteLength < o + 4) return null;
    const len = view.getUint32(o, true);
    o += 4;
    if (buffer.byteLength < o + len) return null;
    tileBytes.push(new Uint8Array(buffer, o, len));
    o += len;
  }

  return { meta, tileBytes };
}

export type { MoveRect, TileImageCodec, TileRect };
